<div class="toggleButton toolbarLabel">
  <input type="checkbox" id="findMultiple" tabindex="0" />
  <label for="findMultiple" data-l10n-id="pdfjs-find-multiple-checkbox-label"></label>
</div>